import { createFileRoute } from '@tanstack/react-router';
import UserLayout from '@components/layout/UserLayout.tsx';
import BasketSavingsPage from '@features/client/basket-savings/BasketSavingsPage.tsx';

/**
 * Detail za kartou „Můj košík" na dashboardu. Samostatná stránka, ne krok objednávkového
 * wizardu (`/basket`) – rozhoduje se tu o cenách, ne o závozu a adrese.
 */
export const Route = createFileRoute('/c/$orgId/$portalId/basket-savings/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <UserLayout>
      <BasketSavingsPage />
    </UserLayout>
  );
}
